import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("via_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("via_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, size = "M", colour = "", qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((it) => it.product_id === product.id && it.size === size && (it.colour || "") === (colour || ""));
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: Math.min(20, next[i].qty + qty) };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: (product.images || [])[0] || "",
          delivery_time: product.delivery_time || "",
          size,
          colour,
          qty,
        },
      ];
    });
  };

  const updateQty = (product_id, size, colour, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((it) => !(it.product_id === product_id && it.size === size && (it.colour || "") === (colour || "")))
        : prev.map((it) => (it.product_id === product_id && it.size === size && (it.colour || "") === (colour || "") ? { ...it, qty: Math.min(20, qty) } : it))
    );

  const remove = (product_id, size, colour) =>
    setItems((prev) => prev.filter((it) => !(it.product_id === product_id && it.size === size && (it.colour || "") === (colour || ""))));

  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, it) => s + it.price * it.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, it) => s + it.qty, 0), [items]);
  const shipping = subtotal === 0 || subtotal >= 50 ? 0 : 3.95;

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, subtotal, count, shipping, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
